import React from 'react';
import { usePermissions } from 'react-admin';
import { Navigate } from 'react-router-dom';

/**
 * Sadece admin rolüne izin verir (DeepL ayarları vb.).
 */
const RequireAdmin = ({ children }) => {
  const { permissions, isLoading } = usePermissions();

  if (isLoading) return null;

  if (permissions?.crole !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default RequireAdmin;
